import React from 'react';

import { Visible } from '../../../core/components';
import { UserContext } from '../../../contexts';

import Value from './Value';

const OrderAddress = ({ order, open }) => {
  const topBorderClass = order?.items?.length > 1 && open ? 'top-border' : '';

  // Orders without a shipping address (e.g. store-to-store cart orders) used
  // to render a fully empty bordered column here — skip the column instead.
  if (!order?.shipping_address) return null;

  return (
    <div className={`col-mid-left ${topBorderClass}`}>
      <div className="item-col">
        <div><Value>{order?.shipping_address?.line1}</Value></div>
        <div><Value>{order?.shipping_address?.line2}</Value></div>
        <div><Value>
          {order?.shipping_address?.postal_code}
          &nbsp;
          {order?.shipping_address?.locality}
        </Value></div>
        <div><Value>{order?.shipping_address?.country?.name}</Value></div>
      </div>
    </div>
  );
};

export default OrderAddress;
